module.exports = __webpack_public_path__ + "img/hazardEquip20.c25af443.jpg";